export default {
    noModels: 'Your Model List Settings exclude all online models.',
    openSettings: 'Change your Model List Settings',
}
